<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.PasswordStrength.title') }}</span>
      <span class="fmt-spacer"/>
      <el-button size="small" @click="generate">{{ $t('tool.PasswordStrength.generate') }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <div class="ps-input-wrap">
      <el-input v-model="pwd" :type="showPwd?'text':'password'" :placeholder="$t('tool.PasswordStrength.phPassword')"
        class="fmt-input" @input="doCheck"/>
      <button class="ps-eye" @click="showPwd=!showPwd" :title="showPwd ? $t('tool.PasswordStrength.hidePassword') : $t('tool.PasswordStrength.showPassword')">
        <svg v-if="showPwd" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
      </button>
    </div>

    <div class="ps-body" v-if="pwd">
      <!-- 强度条 -->
      <div class="ps-bar">
        <div class="ps-bar-fill" :style="{width:score+'%',background:barColor}"></div>
      </div>
      <div class="ps-score">{{ levelText }} · {{ score }}/100</div>

      <!-- 检查项 -->
      <div class="ps-checks">
        <span :class="{ok:chk.len8}">{{ chk.len8 ? '✓' : '✗' }} {{ criteriaText.length }}</span>
        <span :class="{ok:chk.len12}">{{ chk.len12 ? '✓' : '✗' }} {{ criteriaText.length12 }}</span>
        <span :class="{ok:chk.hasUpper}">{{ chk.hasUpper ? '✓' : '✗' }} {{ criteriaText.upper }}</span>
        <span :class="{ok:chk.hasLower}">{{ chk.hasLower ? '✓' : '✗' }} {{ criteriaText.lower }}</span>
        <span :class="{ok:chk.hasDigit}">{{ chk.hasDigit ? '✓' : '✗' }} {{ criteriaText.digit }}</span>
        <span :class="{ok:chk.hasSymbol}">{{ chk.hasSymbol ? '✓' : '✗' }} {{ criteriaText.symbol }}</span>
      </div>
    </div>
    <div class="fmt-status-bar" v-else>
      <span class="fmt-hint">{{ $t('tool.PasswordStrength.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'PasswordStrengthTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return {
      pwd:'',showPwd:false,score:0,levelText:'',barColor:'#e4e7ed',
      chk:{len8:false,len12:false,hasUpper:false,hasLower:false,hasDigit:false,hasSymbol:false}
    }
  },
  computed:{
    criteriaText(){ return { length:this.$t('tool.PasswordStrength.criteria.length'), length12:this.$t('tool.PasswordStrength.criteria.length12'), upper:this.$t('tool.PasswordStrength.criteria.upper'), lower:this.$t('tool.PasswordStrength.criteria.lower'), digit:this.$t('tool.PasswordStrength.criteria.digit'), symbol:this.$t('tool.PasswordStrength.criteria.symbol') } }
  },
  methods:{
    doCheck:function(){
      var t = this.pwd || ''; var l = t.length
      this.chk = {len8:l>=8,len12:l>=12,hasUpper:/[A-Z]/.test(t),hasLower:/[a-z]/.test(t),hasDigit:/\d/.test(t),hasSymbol:/[^A-Za-z0-9]/.test(t)}
      var s = 0
      if(l>=8)s+=20;if(l>=12)s+=15;if(this.chk.hasUpper)s+=15;if(this.chk.hasLower)s+=15
      if(this.chk.hasDigit)s+=15;if(this.chk.hasSymbol)s+=15
      if(this.chk.hasUpper&&this.chk.hasLower&&this.chk.hasDigit)s+=5;if(l>=16)s+=10
      this.score = Math.min(s,100)
      var lv = this.$t('tool.PasswordStrength.levels')
      if(this.score<30){this.levelText=lv[1];this.barColor='#f56c6c'}
      else if(this.score<60){this.levelText=lv[2];this.barColor='#e6a23c'}
      else if(this.score<80){this.levelText=lv[3];this.barColor='#4e7cff'}
      else{this.levelText=lv[4];this.barColor='#67c23a'}
    },
    generate:function(){
      var up='ABCDEFGHJKLMNPQRSTUVWXYZ',lo='abcdefghjkmnpqrstuvwxyz',di='23456789',sy='!@#$%^&*_+-='
      var p=up[(Math.random()*up.length)|0]+lo[(Math.random()*lo.length)|0]+di[(Math.random()*di.length)|0]+sy[(Math.random()*sy.length)|0]
      var all=up+lo+di+sy;for(var i=4;i<16;i++)p+=all[(Math.random()*all.length)|0]
      this.pwd=p.split('').sort(function(){return Math.random()-.5}).join('');this.doCheck()
    },
    doCopy:function(){
      if(!this.pwd){this.$message.warning(this.$t("common.status.noContent"));return}
      navigator.clipboard.writeText(this.pwd);this.$message.success(this.$t("common.status.copied"))
    },
    clearAll:function(){this.pwd='';this.showPwd=false;this.score=0;this.levelText='';this.chk={len8:false,len12:false,hasUpper:false,hasLower:false,hasDigit:false,hasSymbol:false}},
    doAction:function(a){if(a==='clear')this.clearAll();if(a==='copy')this.doCopy()}
  }
}
</script>

<style scoped>
.fmt-tool{display:flex;flex-direction:column;gap:12px;max-width:100%}

.fmt-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.fmt-toolbar >>> .el-button + .el-button{margin-left:0}
.fmt-label{font-size:13px;font-weight:700;color:#1a1f36}
.fmt-spacer{flex:1}

.ps-input-wrap{display:flex;align-items:center;gap:8px}
.ps-input-wrap .fmt-input{flex:1}
.fmt-input >>> input{font-family:'SF Mono',Menlo,Consolas,monospace!important;font-size:14px!important;border-radius:10px}
.ps-eye{display:flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:10px;border:1.5px solid #e1e5e9;background:#fafbfc;color:#909399;cursor:pointer;transition:.12s;flex-shrink:0}
.ps-eye:hover{border-color:#4e7cff;color:#4e7cff}

.ps-body{display:flex;flex-direction:column;gap:8px}
.ps-bar{height:8px;background:#e4e7ed;border-radius:4px;overflow:hidden}
.ps-bar-fill{height:100%;border-radius:4px;transition:all .3s}
.ps-score{font-size:14px;font-weight:600;color:#303133}
.ps-checks{display:flex;gap:14px;flex-wrap:wrap}
.ps-checks span{font-size:12px;color:#c0c4cc;transition:.2s}
.ps-checks span.ok{color:#67c23a}

.fmt-status-bar{font-size:12px}
.fmt-hint{color:#c0c4cc}
</style>
